import { evi2ken } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

type Request = {
  pilotClientId: PilotId;
};

export type ConnectivityTestResult = {
  success: boolean;
  statusCode: number | null;
  message: string;
};

const isAxios404 = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const maybeAxiosError = error as {
    response?: {
      status?: number;
    };
  };

  return maybeAxiosError.response?.status === 404;
};

export const testWorkdayConnectivity = async (
  request: Request,
): Promise<ConnectivityTestResult> => {
  try {
    await evi2ken.get(
      `oauth/ac/tokens/${request.pilotClientId}/workday-connectivity`,
    );

    return {
      success: true,
      statusCode: null,
      message: 'Workday connectivity test succeeded',
    };
  } catch (error: unknown) {
    if (isAxios404(error)) {
      return {
        success: false,
        statusCode: null,
        message: 'Workday connectivity test failed',
      };
    }

    throw error;
  }
};
